module.exports = __webpack_public_path__ + "img/404.d35227e4.jpg";